import { message } from "antd";

/**
 * Initiates a voice call through the GOTO_CALL_URL endpoint
 * @param {Object} params - Call parameters
 * @param {string} params.location_id - The location ID
 * @param {string} params.user_id - The user ID
 * @param {string} params.lead_id - The lead ID
 * @returns {Promise<Object>} - Response from the call API
 */
export const initiateVoiceCall = async ({ location_id, user_id, lead_id }) => {
  try {
    // Show loading message
    const hideLoading = message.loading(
      "Initiating voice call. Please wait while we connect you...",
      2
    );

    const response = await fetch(process.env.GATSBY_GOTO_CALL_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        location_id,
        user_id,
        lead_id,
      }),
    });

    // Hide loading message
    hideLoading();

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    // Show success message with auto-close
    message.success("Voice call initiated successfully!", 3);

    return { success: true, data };
  } catch (error) {
    console.error("Error initiating voice call:", error);

    // Show error message
    message.error("Failed to initiate voice call. Please try again.", 3);

    return { success: false, error: error.message };
  }
};

/**
 * Initiates a voice call with popup notification
 * @param {Object} params - Call parameters
 * @param {string} params.location_id - The location ID
 * @param {string} params.user_id - The user ID
 * @param {string} params.lead_id - The lead ID
 * @param {Function} onSuccess - Optional success callback
 * @param {Function} onError - Optional error callback
 */
export const makeVoiceCall = async (params, onSuccess, onError) => {
  const result = await initiateVoiceCall(params);

  if (result.success) {
    if (onSuccess) onSuccess(result.data);
  } else if (onError) {
    onError(result.error);
  }

  return result;
};
